(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myortica-contackt"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('db-contact')) {
    customElements.define('db-contact', class extends HTMLElement {
      connectedCallback() {
        if (this.copyHandler) return;
        this.querySelectorAll('[data-copy]').forEach(button => { button.hidden = false; });
        this.copyHandler = async event => {
          const button = event.target.closest('[data-copy]');
          if (!button || !this.contains(button)) return;
          const status = this.querySelector('[role="status"]');
          status.textContent = '';
          button.disabled = true;
          let copied = false;
          try {
            if (navigator.clipboard && window.isSecureContext) {
              await navigator.clipboard.writeText(button.dataset.copy);
              copied = true;
            }
          } catch (_) { /* Try the selection fallback below. */ }
          if (!copied) {
            const field = document.createElement('textarea');
            field.value = button.dataset.copy;
            field.setAttribute('readonly', '');
            field.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none;font-size:16px;';
            this.appendChild(field);
            try {
              field.focus({ preventScroll: true });
              field.select();
              field.setSelectionRange(0, field.value.length);
              copied = document.execCommand('copy');
            } catch (_) { copied = false; }
            field.remove();
          }
          button.disabled = false;
          button.focus({ preventScroll: true });
          if (copied) {
  button.querySelector('span').textContent = 'Kopyalandı';
  status.textContent = 'Kopyalandı';

  clearTimeout(button.copyTimer);
  button.copyTimer = setTimeout(() => {
    button.querySelector('span').textContent = 'Kopyala';
    status.textContent = '';
  }, 2000);
} else {
  status.textContent = this.dataset.error;
}
        };
        this.addEventListener('click', this.copyHandler);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.copyHandler);
        this.copyHandler = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
